module.exports = __webpack_public_path__ + "static/media/image-modale.cd5584ba.png";